export default {
    "place": "Ranking",
    "project_name": "Electrolux Academy"
}
